export enum Routes {
  LOGIN = '/login',
  SIGN_OUT = '/signout',

  CONCEPTS = '/concepts',

  CONCEPT_CREATE = '/concept/create',
  CONCEPT_DELETE = '/concept/delete',
  CONCEPT_UPDATE = '/concept/update',

  CONCEPT_GET_DATA = '/concept/data/get',
  CONCEPT_UPDATE_DATA = '/concept/data/update',

  UPLOAD_MEDIA = '/media/upload',
  MEDIA_GET = '/media/get',
  MEDIA_CROP = '/media/crop'
}
